import React, { useState } from "react";

export default function HeaderTabSelector({
  tabs,
  activeTab,
  onChange
}) {
  const [hover, setHover] = useState(null);

  /* ---------------- CONTAINER ---------------- */

  const container = {
    display: "flex",
    height: "36px",
    borderRadius: "999px",
    border: "1px solid rgba(31,111,229,0.25)",
    overflow: "hidden",
    margin: "10px"
  };

  /* ---------------- BASE TAB ---------------- */

  const baseTab = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    minWidth:'120px',
    cursor: "pointer",
    color: "black",
    transition: "all 0.25s ease",
    userSelect: "none"
  };

  /* ---------------- ACTIVE ---------------- */

  const activeTabStyle = {
    background:
      "linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)",
    color: "#fff",
    boxShadow:
      "inset 0 0 6px rgba(255,255,255,0.35)"
  };

  /* ---------------- HOVER ---------------- */

  const hoverStyle = {
	background:
	     "linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)",
	   color: "#fff",
	   boxShadow:
	     "inset 0 0 6px rgba(255,255,255,0.35)"
  };

  return (
    <div style={container}>
      {tabs.map((tab, index) => {
        const isActive = tab.key === activeTab;
        const isFirst = index === 0;
        const isLast = index === tabs.length - 1;

        return (
          <div
            key={tab.key}
            style={{
              ...baseTab,
              ...(isActive ? activeTabStyle : {}),
              ...(hover === tab.key && !isActive ? hoverStyle : {}),
              borderRight:
                !isLast ? "1px solid rgba(31,111,229,0.25)" : "none",
              borderTopLeftRadius: isFirst ? "999px" : 0,
              borderBottomLeftRadius: isFirst ? "999px" : 0,
              borderTopRightRadius: isLast ? "999px" : 0,
              borderBottomRightRadius: isLast ? "999px" : 0
            }}
            onMouseEnter={() => setHover(tab.key)}
            onMouseLeave={() => setHover(null)}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );
}
